export var SumsubSdkStatus;
(function (SumsubSdkStatus) {
    SumsubSdkStatus["NOT_INITIALIZED"] = "NotInitialized";
    SumsubSdkStatus["READY"] = "Ready";
    SumsubSdkStatus["FAILED"] = "Failed";
    SumsubSdkStatus["INITIAL"] = "Initial";
    SumsubSdkStatus["INCOMPLETE"] = "Incomplete";
    SumsubSdkStatus["PENDING"] = "Pending";
    SumsubSdkStatus["TEMPORARILY_DECLINED"] = "TemporarilyDeclined";
    SumsubSdkStatus["FINALLY_REJECTED"] = "FinallyRejected";
    SumsubSdkStatus["APPROVED"] = "Approved";
    SumsubSdkStatus["ACTION_COMPLETED"] = "ActionCompleted";
})(SumsubSdkStatus || (SumsubSdkStatus = {}));
export var LogLevel;
(function (LogLevel) {
    LogLevel["OFF"] = "OFF";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["INFO"] = "INFO";
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["TRACE"] = "TRACE";
    LogLevel["UNKNOWN"] = "UNKNOWN";
})(LogLevel || (LogLevel = {}));
// TODO:
export var SumsubErrorType;
(function (SumsubErrorType) {
    /** Unknown or no fail */
    SumsubErrorType["Unknown"] = "Unknown";
    /** An attempt to setup with invalid parameters */
    SumsubErrorType["InvalidParameters"] = "InvalidParameters";
    /** Unauthorized access detected (most likely accessToken is invalid or expired and had failed to be refreshed) */
    SumsubErrorType["Unauthorized"] = "Unauthorized";
    /** Initial loading from backend is failed */
    SumsubErrorType["InitialLoadingFailed"] = "InitialLoadingFailed";
    /** No applicant is found for the given parameters */
    SumsubErrorType["ApplicantNotFound"] = "ApplicantNotFound";
    /** Applicant is found, but is misconfigured (most likely lacks of idDocs) */
    SumsubErrorType["ApplicantMisconfigured"] = "ApplicantMisconfigured";
    /** An initialization error occurred */
    SumsubErrorType["InitializationError"] = "InitializationError";
    /** A network error occurred (the user will be presented with Network Oops screen) */
    SumsubErrorType["NetworkError"] = "NetworkError";
    /** Some unexpected error occurred (the user will be presented with Fatal Oops screen) */
    SumsubErrorType["UnexpectedError"] = "UnexpectedError";
})(SumsubErrorType || (SumsubErrorType = {}));
//# sourceMappingURL=definitions.js.map